import { useState, Fragment, useEffect } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import { toast } from "react-toastify";
import { customToastify, checkResponseData, checkErrorMessage } from "../../../../utils/utilsFunctions";
import Box from "@mui/material/Box";
import CreateNewBox from "./CreateNewBox";
import { Link } from "react-router-dom";
import { Typography, Button, Divider } from "@mui/material";
import { getBoxesListApi } from "../../../../../../services/leitnerApi";

export default function SelectLeitner(props) {
  const {
    selectedLeitner, handleSelectedLeitner
  } = props;
  const [boxesList, setBoxesList] = useState([{}]);
  const [selectLeitner, setSelectLeitner] = useState("");
  const [openNewBox, setOpenNewBox] = useState(false);

  const hsndleOpenNewBox = () => {
    setOpenNewBox(!openNewBox);
  };


  const handleEditBoxlist = (data) => {
    setBoxesList(data);
  };

  const loadBoxLists = async () => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const getBoxesList = await getBoxesListApi({})
      const res = checkResponseData(getBoxesList);
      if (res["success"]) {
        toast.update(toastMsg, { render: res["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });

        setBoxesList(checkResponseData(getBoxesList)["data"]["docs"]);
        if (selectedLeitner && selectedLeitner["id"]) {
          setSelectLeitner(selectedLeitner["id"])
        }
      } else {
        toast.update(toastMsg, { render: res["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
        setBoxesList([{}]);
        // customToastify(
        //   "error",
        //   "مشکلی در دریافت لیست لایتنرها وجود دارد",
        //   5000,
        //   "bottom-center"
        // );
      }
    } catch (error) {
      console.log("loadBoxLists", error);
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
    }
  };

  useEffect(() => {
    loadBoxLists();
  }, []);

  return (
    <Box sx={{ height: "50vh", overflowY: "scroll" }} >
      <List dense={true} component="nav">
        {boxesList.length == 0 ? (
          <Typography
            sx={{ textAlign: "center", mt: 1, fontWeight: "bold" }}
          >
            لایتنری تا کنون نساخته اید
          </Typography>
        ) : (
          boxesList.map(({ _id, name, secondary }, index) => (
            <Fragment key={index + _id}>
              <ListItemButton
                onClick={() => {
                  // console.log(_id);
                  setSelectLeitner(_id);
                  handleSelectedLeitner({ id: _id, name })
                  //   setBoxDetails(true, _id);
                }}
                sx={{
                  backgroundColor: selectLeitner == _id ? "#218f39" : "", "&:hover": {
                    backgroundColor: "#508f5e"
                  }
                }}
              >
                <ListItemIcon>
                  <KeyboardDoubleArrowLeftIcon />
                </ListItemIcon>
                <ListItemText primary={name} />
              </ListItemButton>
              <Divider />
            </Fragment>
          ))
        )}
      </List>
      <Box sx={{ textAlign: "center", mt: 1 }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={hsndleOpenNewBox}
        >
          ساخت میزکار جدید
        </Button>
      </Box>
      <CreateNewBox
        openNewBox={openNewBox}
        hsndleOpenNewBox={hsndleOpenNewBox}
        boxesList={boxesList}
        handleEditBoxlist={handleEditBoxlist}
      />
    </Box>
  );
}
